import React from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Components
import Textfield from "../../../../../../components/inputs/input";
import Dropdown from '../../../../../../components/inputs/dropdown';
import Autocomplete from '../../../../../../components/inputs/Autocomplete';

// Models
import { utils } from "../../../../../../utils/utils";

//Hooks
import useCashRegisterMovementReasons from '../../../../../../hooks/cashRegisterMovementReasons/useCashRegisterMovementReasons';

const Transfer = ({ totals, movement, setMovement, fixedAmount, totalAmountImprest, cashRegisters }) => {
  const { cashRegisterMovementReasons } = useCashRegisterMovementReasons({
    type: movement.type,
    subType: movement.subType
  });
  const handleValueChange = (event) =>
    setMovement({
      ...movement,
      [event.target.name]: event.target.value,
    });

  const handleAutocompleteChange = (event, options) => {
    setMovement({
      ...movement,
      cashRegisterDestination: options
    });
  }

  const GetCashTotal = () =>
    totals?.[`Cash${movement.currency}`]?.total || 0;

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Box display="flex" justifyContent='center'>
          <Typography variant="body1">
            {`Transferencia de efectivo ${!movement.cashRegisterDestination?.name ? '' : `a ${movement.cashRegisterDestination.name}`}`}
          </Typography>
        </Box>
      </Grid>
      <Grid size={12}>
        <Autocomplete
          fullWidth
          size='small'
          options={cashRegisters}
          getOptionLabel={(option) => option?.name || ""}
          renderOption={(props, option) => <li {...props}><span>{option?.name}</span></li>}
          onChange={handleAutocompleteChange}
          value={movement.cashRegisterDestination || ""}
          loadingText='Buscando cajas...'
          TextProps={{
            label: 'Seleccionar Caja de destino'
          }}
        />
      </Grid>
      <Grid size={12}>
        <Dropdown
          required
          fullWidth
          name='reasonId'
          label='Seleccionar Motivo'
          onChange={handleValueChange}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.description}
          values={cashRegisterMovementReasons}
          value={movement.reasonId || ""}
        />
      </Grid>
      <Grid size={12}>
        <Textfield
          required
          fullWidth
          size="small"
          name="amount"
          label="Monto a transferir"
          type="number"
          onChange={handleValueChange}
          value={movement.amount || ""}
        />
      </Grid>
      <Grid size={6}>
        <Box display="flex" justifyContent='flex-start'>
          <Typography color="primary" variant="body1" gutterBottom>
            Importe en efectivo:&nbsp;
          </Typography>
          <Typography variant="body1">
            <strong>{utils.formatMoney(GetCashTotal())}</strong>
          </Typography>
        </Box>
        <Box display="flex" justifyContent='flex-start'>
          <Typography color="primary" variant="body1" gutterBottom>
            Saldo restante:&nbsp;
          </Typography>
          <Typography variant="body1">
            <strong>
              {utils.formatMoney(GetCashTotal() - movement.amount)}
            </strong>
          </Typography>
        </Box>
      </Grid>
      {movement.cashRegisterDestination?.isImprest &&
        <Grid size={6}>
          <Box display="flex" justifyContent='flex-end'>
            <Typography color="primary" variant="body1" gutterBottom>
              Efectivo en Fondo fijo:&nbsp;
            </Typography>
            <Typography variant="body1">
              <strong>
                {utils.formatMoney((totalAmountImprest || 0) + Number(movement.amount))}
              </strong>
            </Typography>
          </Box>
          <Box display="flex" justifyContent='flex-end'>
            <Typography color="primary" variant="body1" gutterBottom>
              Fondo fijo disponible:&nbsp;
            </Typography>
            <Typography variant="body1">
              <strong>
                {utils.formatMoney((fixedAmount || 0))}
              </strong>
            </Typography>
          </Box>
        </Grid>
      }
    </Grid>
  );
};

export default Transfer;
